import React from "react";
import { Link, NavLink, useNavigate } from "react-router-dom";
import { Menu, X, ChevronDown } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import UserChip from "@/components/UserChip";

const NAV = [
  { to: "/", label: "Home" },
  { to: "/how-it-works", label: "How It Works" },
  { to: "/for-sellers", label: "For Sellers" },
  { to: "/for-investors", label: "For Investors" },
  { to: "/for-professionals", label: "For Professionals" },
  { to: "/pricing", label: "Pricing" },
  { to: "/download", label: "Get App" },
];

export default function Navbar() {
  const [open, setOpen] = React.useState(false);
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  return (
    <header
      className="bg-[var(--adn-navy)] text-white sticky top-0 z-40 grain"
      style={{ paddingTop: "env(safe-area-inset-top)" }}
    >
      <div className="max-w-7xl mx-auto px-6 md:px-10 h-16 flex items-center justify-between" style={{ paddingLeft: "max(1.5rem, env(safe-area-inset-left))", paddingRight: "max(1.5rem, env(safe-area-inset-right))" }}>
        <Link to="/" data-testid="nav-logo" className="flex items-center gap-3">
          <div className="h-8 w-8 rounded-sm bg-[var(--adn-gold)] flex items-center justify-center text-[var(--adn-navy)] font-bold font-display">A</div>
          <div className="flex flex-col leading-none">
            <span className="font-display font-semibold text-[15px] tracking-wide">ADN Marketplace</span>
            <span className="text-[10px] tracking-[0.18em] uppercase text-[var(--adn-gold)]/90 mt-0.5">Distressed Property Network</span>
          </div>
        </Link>

        <nav className="hidden lg:flex items-center gap-1">
          {NAV.map((n) => (
            <NavLink
              key={n.to}
              to={n.to}
              data-testid={`nav-${n.to.replace("/", "") || "home"}`}
              className={({ isActive }) =>
                `px-3 py-2 text-sm font-medium rounded transition-colors ${
                  isActive ? "text-[var(--adn-gold)]" : "text-white/80 hover:text-white"
                }`
              }
            >
              {n.label}
            </NavLink>
          ))}
        </nav>

        <div className="hidden lg:flex items-center gap-3">
          {user ? (
            <UserChip dark />
          ) : (
            <>
              <Link to="/login" data-testid="nav-login" className="text-sm text-white/85 hover:text-white px-3 py-2">
                Login
              </Link>
              <Link
                to="/submit-property"
                data-testid="nav-submit-property"
                className="btn-gold px-5 py-2.5 rounded text-sm"
              >
                Submit My Property
              </Link>
            </>
          )}
        </div>

        <button
          aria-label="Menu"
          data-testid="nav-menu-toggle"
          onClick={() => setOpen((o) => !o)}
          className="lg:hidden p-2 -mr-2 text-white"
        >
          {open ? <X size={22} /> : <Menu size={22} />}
        </button>
      </div>

      {open && (
        <div className="lg:hidden border-t border-white/10 bg-[var(--adn-navy)]">
          <div className="max-w-7xl mx-auto px-6 py-4 flex flex-col">
            {NAV.map((n) => (
              <Link
                key={n.to}
                to={n.to}
                onClick={() => setOpen(false)}
                data-testid={`m-nav-${n.to.replace("/", "") || "home"}`}
                className="py-2.5 text-sm text-white/85"
              >
                {n.label}
              </Link>
            ))}
            <div className="pt-3 mt-2 border-t border-white/10 flex gap-3">
              {user ? (
                <>
                  <Link to="/dashboard" onClick={() => setOpen(false)} className="btn-outline-light px-4 py-2 rounded text-sm">Dashboard</Link>
                  <button onClick={logout} className="btn-gold px-4 py-2 rounded text-sm">Sign Out</button>
                </>
              ) : (
                <>
                  <Link to="/login" onClick={() => setOpen(false)} className="btn-outline-light px-4 py-2 rounded text-sm">Login</Link>
                  <Link to="/submit-property" onClick={() => setOpen(false)} className="btn-gold px-4 py-2 rounded text-sm">Submit My Property</Link>
                </>
              )}
            </div>
          </div>
        </div>
      )}
    </header>
  );
}
